import { Component, OnInit } from '@angular/core';
import { SearchRequest, SimpleNavigation } from '@usf/product-types';
import { SearchFiltersBaseComponent } from '../search-filters-base.component';
import { SearchFilterSelected } from '@search/shared/models/search-filter-selected';
import { FilterRequestModel } from '@search/shared/models/filter-request-model';

@Component({
  selector: 'app-search-filtering',
  templateUrl: './search-filtering.component.html',
  styleUrls: ['./search-filtering.component.scss'],
})
export class SearchFilteringComponent
  extends SearchFiltersBaseComponent
  implements OnInit {
  filterNavigation: SimpleNavigation[];

  ngOnInit(): void {
    super.ngOnInit();
    this.filterNavigation = this.navigation?.filter(
      filterNav =>
        (filterNav?.refinementType === 'RefinementMenu' &&
          !!filterNav.displayName &&
          (!!filterNav.staticRefinements.length ||
            !!filterNav.refinements.length)) ||
        (filterNav?.refinementType === 'RangeRefinementMenu' &&
          filterNav?.rangeRefinements?.length > 0),
    );
  }

  refreshSearchResult(filterRequestModel: FilterRequestModel): void {
    if (filterRequestModel?.searchFilterSelected?.refinementItem) {
      this.searchFilterService.trackAppliedSearchFilters(
        this.requestQueryParam,
        this.searchResponse,
        filterRequestModel?.searchFilterSelected,
      );
    }
    this.selectFilterOption.emit(filterRequestModel);
  }
}
